const locationsTemplate = document.getElementById('tmpl-report-locations')

const checkboxTemplate = document.createElement('template')
checkboxTemplate.innerHTML = `
    <div class="form-control">
        <input class="hidden" type="checkbox" id="toggle_1" value="1">
        <label class="rounded-label" for="toggle_1">
          <span class="rounded-checkbox"></span>
        </label> <span class="checkbox-label">Another location</span>
      </div>
`

export default class MTReportLocations extends HTMLElement {
    constructor() {

        super()

        this.attachShadow({
            mode: 'open'
        })

        this.shadowRoot.appendChild(locationsTemplate.content.cloneNode(true))

        this.singleLocationContainer = this.shadowRoot.querySelector(
            '#js-single-yard'
        )

        this.singleLocationName = this.shadowRoot.querySelector(
            '#js-single-yard--name'
        )

        this.multipleLocationsContainer = this.shadowRoot.querySelector(
            '#js-multiple-yards'
        )

    }

    get locations() {
        return this._locations
    }

    set locations(value) {
        this._locations = value

        const locationsLength = this._locations.length
        if (locationsLength === 1) {
            this.displaySingleLocation()
        } else {
            this.displayMultipleLocations()
        }
    }

    displaySingleLocation() {
        this.singleLocationName.innerText = this._locations[0].name
    }

    checkboxTemp(props) {
        return `
                <input class="hidden" type="checkbox" data-id="${
                    props.id
                }" id="location_${props.id}" value="${props.id}" ${
            props.isSelected ? 'checked' : ''
        }>
                <label class="rounded-label" for="location_${props.id}">
                <span class="rounded-checkbox"></span>
                </label> <span class="checkbox-label">${props.name}</span>

        `
    }

    displayMultipleLocations() {
        this.singleLocationContainer.classList.add('hidden')
        this.multipleLocationsContainer.classList.remove('hidden')
        const contentSection = this.multipleLocationsContainer.querySelector(
            '#js-locations-container'
        )
        this._locations.forEach((l) => {
            const checkboxContainer = document.createElement('div')
            checkboxContainer.classList.add('mt-location-container')

            checkboxContainer.innerHTML = this.checkboxTemp(l)
            contentSection.appendChild(checkboxContainer)
        })
        const locationCheckboxes = contentSection.querySelectorAll(
            'input[data-id]'
        )
        locationCheckboxes.forEach((l) => {
            l.addEventListener(
                'click',
                (e) => {
                    console.info(this)
                    this.dispatchEvent(
                        new CustomEvent('locationChange', {
                            detail: l.dataset.id,
                        })
                    )
                },
                false
            )
        })
    }

    connectedCallback() {}

    render() {}
}

customElements.define('mt-report-locations', MTReportLocations)
